<ng-container *transloco="let t">
  @if (showSuccess()) {
    <div
      class="d-flex aside-validation-success justify-content-center align-items-center w-100 flex-column"
    >
      <lib-icon
        name="check-circle"
        class="validation-success"
        size="large"
        aria-hidden="true"
      ></lib-icon>
      <p class="ingress">
        {{ successMessage() }}
      </p>
    </div>
  }
  @if (formGroup().invalid && validationList()) {
    <div class="d-flex aside-validation-error w-100 flex-column">
      @for (section of validationList().sections; track section.id) {
        <div class="d-flex justify-content-between">
          <button
            vinnova-button-text
            size="small"
            type="button"
            class="section-link"
            (click)="goToSection(section.id)"
            [attr.aria-label]="
              t('aside_validation_section_label', {
                section: section.title,
              })
            "
          >
            {{ section.title }}
          </button>
        </div>

        @for (question of section.questions; track question.id) {
          <lib-aside-validation-item
            [sectionId]="section.id"
            [question]="question"
            (goToQuestion)="goToQuestion($event.questionId, $event.sectionId)"
          ></lib-aside-validation-item>
          @for (
            subQuestion of question.invalidSubquestions;
            track subQuestion.repeaterId + '_' + subQuestion.id
          ) {
            <lib-aside-validation-item
              [sectionId]="section.id"
              [question]="subQuestion"
              (goToQuestion)="
                goToQuestion(
                  $event.questionId,
                  $event.sectionId,
                  $event.repeaterId
                )
              "
            ></lib-aside-validation-item>
          }
        }
      }
    </div>
  }
</ng-container>
